export default __webpack_public_path__ + "static/media/fingerprint.a786470e.png";